import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { getBackButtonMeta } from '../helpers/App';

const GoBackToListButton = ({
  location,
  goBackUrl,
  goBackText,
  scope,
}) => {
  if (!(location.state?.goBackToListButton || goBackUrl) && !scope) {
    return null;
  }

  const getGoBackButton = () => {
    if (location.state?.goBackToListButton) {
      return location.state;
    }

    if (goBackUrl) {
      return {
        goBackToListButton: {
          pathname: goBackUrl,
          text: goBackText,
        },
      };
    }

    if (scope) {
      return {
        goBackToListButton: getBackButtonMeta(scope),
      };
    }

    return null;
  };

  const goBackToListButtonMeta = getGoBackButton();

  if (!goBackToListButtonMeta) {
    return null;
  }

  const { goBackToListButton } = goBackToListButtonMeta;

  return (
    <div className="go-back-to-list-wrapper">
      <Link to={{
        pathname: goBackToListButton?.pathname || goBackUrl,
        search: goBackToListButton?.search,
      }}
      >
        <span className="go-back-to-list-button">
          <i className="far fa-arrow-left" /> {goBackToListButton?.text}
        </span>
      </Link>
    </div>
  );
};

GoBackToListButton.propTypes = {
  location: PropTypes.object.isRequired,
  goBackUrl: PropTypes.string,
  goBackText: PropTypes.string,
  scope: PropTypes.string,
};

GoBackToListButton.defaultProps = {
  goBackUrl: null,
  goBackText: null,
  scope: null,
};

export default withRouter(GoBackToListButton);
